import {email} from "vuelidate/lib/validators";
import {helpers} from '@vuelidate/validators';

export const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)) // use for convert not validation
export const a2e = s => s.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)) // use for convert not validation

export const phone = (value) => {
    value = p2e(a2e(value))

    const regex = /^09[0-9]{9}$/g;
    const found = value.match(regex);

    return found == null ? false : true

}
export const telphone = (value) => {
    value = p2e(a2e(value))

    const regex = /^[0-9]{11}$/g;
    const found = value.match(regex);

    return found == null ? false : true

}
export const postalcode = (value) => {
    value = p2e(a2e(value))

    const regex = /\d+/g;
    const found = value.match(regex);

    return found == null ? false : true

}
export const emailOrPhone = (value) => or(email, phone(value))

export const slug = helpers.regex(/^\S*$/)
export const phoneStartWith98 = helpers.regex(/(\+98)[0-9]{10}/);